import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import s from './Tabs.scss';
import GalleryTab from '../Gallery';
import VideoTab from '../Video';

// TODO: enable when video greeting done
const VIDEO_DISABLED = true;

const CustomTabs = ({ formatMessage, messages, ...props }) => (
  <Tabs
    selectedTabClassName={s['tab--selected']}
    selectedTabPanelClassName={!VIDEO_DISABLED ? s['panel--selected'] : null}
  >
    <TabList
      className={s.list}
      style={VIDEO_DISABLED ? { display: 'none' } : null}
    >
      <Tab className={s.tab}>{formatMessage({ ...messages.images })}</Tab>
      <Tab className={s.tab}>{formatMessage({ ...messages.video })}</Tab>
    </TabList>
    <TabPanel className={s.panel}>
      <GalleryTab
        {...props}
        formatMessage={formatMessage}
        messages={messages}
      />
    </TabPanel>
    <TabPanel className={s.panel}>
      <VideoTab {...props} formatMessage={formatMessage} messages={messages} />
    </TabPanel>
  </Tabs>
);

CustomTabs.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.shape().isRequired,
};

export default withStyles(s)(CustomTabs);
